<template>
	<div class="shop_detial" v-loading="loading">
		 <div class="shop_detial_box">
            <div class="title_box">
                <!-- <img src="../../assets/img/login/Frame.png" alt=""> -->
                <span class="span1">首页</span>
                > 
                <span class="span2">更多服务 </span>
                > 
                <span class="span2">积分商城</span>
                > 
                <span class="span2">详情</span>
             </div>
             <div class="shop_flex">
                <div class="shop_left">
                    <div class="shop_box1">
                        <div class="shop_banner">
                            <div class="banner_top">
                                <img :src="banner_img" alt="">
                            </div>
                            <div class="banner_bom">
                                <div class="banner_btns" @click="handle_num_clear">
                                    <img src="@/assets/img/index/legal/banner_left.png" alt="">
                                </div>
                              
                                <div class="banner_list" ref="banner_list">
                                    <div class="banner_img" v-for="(item,index) in banner_list" :key="index" @click="handle_banner(item,index)" :class="{banner_img_ac:banner_ac==index}">
                                        <img :src="item.imgs" alt="">
                                    </div>  
                                </div>
                                <div class="banner_btns" @click="handle_num_add">
                                    <img src="../../../assets/img/index/legal/banner_right.png" alt="">
                                </div>
                            </div>
                        </div>
                        <div class="shop_info">
                            <div class="shop_infp_top">
                                <div class="shop_title">{{ detials.title }}</div>
                                <div class="shop_jian">
                                    {{detials.desc}}
                                </div>
                            </div>
                            <div class="shop_infp_bom">
                                <div class="shop_price_num">
                                    <div class="shop_price">
                                        <div class="shop_price_text">价格</div>
                                        <div class="shop_price_nums">
                                            {{ detials.jifen }}
                                            <span>积分</span>
                                            {{  detials.money!=0?'+':'' }}
                                            {{ detials.money!=0?detials.money:'' }}
                                            
                                            <span v-if=" detials.money!=0">元</span> 
                                        </div>
                                    </div>
                                    <div class="shop_num">
                                        兑换量 {{ detials.sale_num }}
                                    </div>
                                </div>
                                <div class="shop_btns">
                                    <div class="btns" @click="handle_dh">立即兑换</div>
                                </div>
                            </div>
                        </div>


                    </div>
                    <div class="shop_box2">
                        <div class="type_list">
                            <!--  v-for="(item,index) in type_list" :key="index" -->
                            <div class="type_item">
                                产品介绍
                            </div>
                        </div>
                        <div class="shop_consts">
                            <div v-html="detials.content"></div>
                        </div>
                    </div>

                </div>
                <div class="shop_right">
                    <div class="shop_list" v-for="(item,index) in list" :key="index">
                        <div class="shop_imgs">
                            <!-- <img src="@/assets/img/index/legal/bg1.png" alt=""> -->
                             <img :src="item.thumb" alt="">
                        </div>
                        <div class="shop_info">
                            <div class="shop_title">{{ item.title }}</div>
                            <div class="shop_price_btn">
                                <div class="shop_price">
                                    {{ item.jifen }}
                                    <span>积分</span>
                                </div>
                                <div class="shop_btns">兑换</div>
                            </div>
                        </div>
                    </div>
                </div>
             </div>
         </div>
        <legal_check ref="legal_check"></legal_check>
       
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
import legal_check from '@/components/Legal/legal_check.vue'//选择
	 
	export default {
		components: {
        legal_check
		 
		},
		name: "index",
		data() {
			return {
				loading:false,
                detials:{},
                banner_ac:0,
                banner_img:'',
                banner_list:[],
              
                list:[],
			}
		},
		computed: {
			 
		},
		watch: {
            banner_ac(newobj,oldobj){
                console.log('切换')
                this.$refs.banner_list.scrollTo({
                    left: 90*(this.banner_ac-1),
                    behavior: "smooth",
                })
                this.banner_img=this.banner_list[this.banner_ac].imgs
                // this.$refs.banner_list.scrollLeft=
            },
		},
		created() {
            this.get_detial()
            // this.get_list()
		},
		methods: {
            get_detial(){
                this.loading = true
                this.$api("jifenPro", {
                    id:this.$route.query.id,
                }, "get").then((res) => {
                    this.loading = false
                    console.log('积分商品详情',res)
                    if (res.code == 1) {
                        this.detials=res.data
                        res.data.images.forEach((e,i)=>{
                            if(i==0){
                                this.banner_img=e
                            }
                            this.banner_list.push({
                                imgs:e
                            })
                        })
                    } else {
                        alertErr(res.msg)
                    }
                });
            },
		    //图片
            handle_banner(item,index){
                this.banner_ac=index
            },
            handle_num_clear(){
                if(this.banner_ac==0){

                }else{
                    this.banner_ac--
                }
            },
            handle_num_add(){
                if((this.banner_list.length-1)==this.banner_ac){

                }else{
                    this.banner_ac++
                }
            },
            get_list(){
                this.loading = true
                this.$api("jifenShop", {
                    limit:3,
                }, "get").then((res) => {
                    this.loading = false
                    console.log('积分商品列表',res)
                    if (res.code == 1) {
                        this.list=res.data.data
                    } else {
                        alertErr(res.msg)
                    }
                });
            },
            handle_dh(){
                this.loading = true
                this.$api("jifenBuy", {
                    id:this.$route.query.id
                }, "post").then((res) => {
                    this.loading = false
                    console.log('积分兑换',res)
                    if (res.code == 1) {
                        this.$refs.legal_check.handle_open(this.detials,2,1,res.data.order_id)
                    } else {
                        alertErr(res.msg)
                    }
                });
            },

		},

	}
</script>
<style scoped lang="less">
	.shop_detial {
		background: #F5F5F5;
        padding-bottom: 100px;
        padding-top: 20px;
        .shop_detial_box{
            width: 1440px;
            margin: auto;
            .title_box{
                padding-bottom: 21px;

                display: flex;
                align-items: center;

                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 14px;
                color: #999999;
                .span1{
                    cursor: pointer;
                    margin-right: 10px;
                }
                .span2{
                    cursor: pointer;
                    margin-left: 10px;
                }
                img{
                    margin-right: 10px;
                }
            }
            .shop_flex{
                display: flex;
                justify-content: space-between;
                .shop_left{
                    padding-right:24px;
                    flex: 1;
                    .shop_box1{
                        // width: 1000px;
                        height: 432px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        padding: 30px 32px 40px 32px;
                        display: flex;
                        
                        .shop_banner{
                            width: 340px;
                            flex-shrink: 0;
                            .banner_top{
                                width: 340px;
                                height: 300px;
                            }
                            .banner_bom{
                                margin-top: 10px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .banner_btns{
                                    width: 20px;
                                    height: 56px;
                                    background: #F5F5F5;
                                    border-radius: 4px 0px 0px 4px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    img{
                                        width: 8px;
                                        height: 14px;
                                    }
                                }

                                .banner_list{
                                    width: 280px;
                                    overflow-x: scroll;
                                    display: flex;
                                    align-items: center;
                                    padding: 0 10px;
                                    margin: auto;
                                    .banner_img{
                                        width: 80px;
                                        height: 60px;
                                        margin-right: 10px;
                                        flex-shrink: 0;
                                        cursor: pointer;
                                        border-radius: 4px 4px 4px 4px;
                                        transition: all .5s ease;
                                        img{
                                            width: 80px;
                                            height: 56px;
                                            border-radius: 4px 4px 4px 4px;
                                            border: 2px solid #FFFFFF;

                                        }
                                    }
                                    .banner_img:last-child{
                                        margin-right: 0px;
                                    }
                                    &::-webkit-scrollbar {
                                        display: none;
                                    }
                                    .banner_img_ac{
                                        img{
                                            border: 1px solid #377CFD;
                                        }
                                    }
                                    
                                }
                            }
                        }
                        .shop_info{
                            flex: 1;
                            padding-left: 24px;
                            display: flex;
                            align-content: space-between;
                            flex-wrap: wrap;
                            .shop_infp_top{
                                width: 100%;
                                .shop_title{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 24px;
                                    color: #333333;
                                }
                                .shop_jian{
                                    padding-top: 24px;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #666666;
                                }

                            }
                            .shop_infp_bom{
                                width: 100%;
                                .shop_price_num{
                                    width: 100%;
                                    // width: 572px;
                                    height: 64px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    border-radius: 0px 0px 0px 0px;
                                    padding: 0 24px;
                                    background: url('../../../assets/img/index/shop/bg1.png');
                                    background-size: 100%;

                                    .shop_price{
                                        display: flex;
                                        align-items:center;
                                        .shop_price_text{
                                            width: 100px;
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: 400;
                                            font-size: 14px;
                                            color: #999999;
                                            line-height: 64px;
                                            letter-spacing: 30px;
                                        }
                                        .shop_price_nums{
                                            font-family: Microsoft YaHei, Microsoft YaHei;
                                            font-weight: bold;
                                            font-size: 20px;
                                            color: #FD4C5C;
                                            span{
                                                font-size: 12px;
                                            }

                                        }
                                    }
                                    .shop_num{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #666666;
                                    }
                                 
                                }
                                .shop_btns{
                                    display: flex;
                                    align-items: center;
                                    padding-top: 26px;
                                    .btns{
                                        width: 134px;
                                        height: 40px;
                                        background: #377CFD;
                                        border-radius: 4px 4px 4px 4px;
                                        border: 1px solid #377CFD;
                                        line-height: 40px;
                                        cursor: pointer;
                                        text-align: center;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: bold;
                                        font-size: 14px;
                                        color: #FFFFFF;

                                    }
                                }
                            }
                        }
                    }
                    .shop_box2{
                        // height: 100px;
                        margin-top: 24px;
                        background: #FFFFFF;

                        .type_list{
                            height: 60px;
                            background: #FFFFFF;
                            border-radius: 0px 0px 0px 0px;
                            border-bottom: 1px solid #EEEEEE;
                            .type_item{
                                width: 120px;
                                height: 60px;
                                border-radius: 0px 0px 0px 0px;
                                background: rgba(55, 124, 253, 0.04);
                                text-align: center;
                                line-height: 60px;
                                border-top: 3px solid #377CFD;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 16px;
                                color: #377CFD;
                            }
                        }
                        .shop_consts{
                            padding: 20px 30px;
                        }
                    }
                }
                .shop_right{
                    width: 416px;
                    .shop_list{
                        width: 416px;
                        height: 337px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        border: 1px solid #D7D7D7;
                        margin-bottom: 24px;
                        cursor: pointer;
                        .shop_imgs{
                            width: 416px;
                            height: 238px;
                            img{
                                width: 416px;
                                height: 238px;
                            }
                        }
                        .shop_info{
                            padding:  16px;
                            display: flex;
                            align-content: space-between;
                            flex-wrap: wrap;
                            height: 100px;
                            .shop_title{
                                width: 100%;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 16px;
                                color: #333333;
                            }
                            .shop_price_btn{
                                width: 100%;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                                .shop_price{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 20px;
                                    color: #FD4C5C;
                                    span{
                                        font-size: 12px;
                                    }

                                }
                                .shop_btns{
                                    width: 64px;
                                    height: 24px;
                                    background: #377CFD;
                                    border-radius: 3px 3px 3px 3px;
                                    text-align: center;
                                    line-height: 24px;
                                    cursor: pointer;              
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: #FFFFFF;

                                }
                            }
                        }
                    }
                }

            }
        }
        
	}
</style>